import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const noOfQualifiedSurveyAction = createAsyncThunk(
    'no-of-qualified-survey',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/support-server/api/no-of-qualified-survey?&s_date=${data?.s_date}&e_date=${data?.e_date}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const noOfQualifiedSurveySlice = createSlice({
    name: 'no-of-qualified-survey',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(noOfQualifiedSurveyAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(noOfQualifiedSurveyAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(noOfQualifiedSurveyAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const noOfQualifiedSurveyReducer = noOfQualifiedSurveySlice.reducer